import React, { useState } from 'react'
import { useNavigate } from 'react-router';
import { formatDate } from '../../helper/formatDate';
import { useTranslate } from '../TranslationText';
import CustomPopUp from '../CustomPopUp';
import EahsForm from '../EahsForm';
import { addedithorsequalification, addHorseCertificates, deleteShowEntry, getCountries, getHorseCertificates, gethorsequalificationbyhorseid } from '../../pages/showEntry/apis/CreateShowEntry';
import { isValidUrl } from '../../helper/validateURL';
import { eformInput } from '../../common/cssclasses';
import NetaqInput from '../NetaqInput';
import { isEmpty } from '../../helper/validaiteInputs';
import UploadFile from '../SimpleFileUpload';
import { convertToCamelCase } from '../../helper/convertToCamelCase';


const BaseURL = process.env.REACT_APP_BASE_URL;
export default function ShowEntryHorseCard({ horse, onClick, isSelectedTab = false, showId, showDetails = {}, toast }) {
    const navigate = useNavigate();
    const { translate } = useTranslate();
    const [countriesData, setCountriesData] = useState([]);
    const isInternationalHorse = ((horse?.status?.toLowerCase() == 'returned' || (horse?.status == "" || horse?.status?.toLowerCase() == 'draft') && !horse?.isRegisterd && !horse?.isEarlyYearlingHorse))
    const isFoalHorse = ((horse?.status?.toLowerCase() == 'returned' || (horse?.status == "" || horse?.status?.toLowerCase() == 'draft') && !horse?.isRegisterd && !!horse?.isEarlyYearlingHorse))
    const [isSending, setIsSending] = useState(false);
    const [selectedDay, setSelectedDay] = useState({});
    const [step, setStep] = useState(1);
    const [vaccinationCertificate, setVaccinationCertificate] = useState([]);
    const [jawCertificate, setJawCertificate] = useState([]);

    const certInit = {
        iDontHaveJawCertificate: false,
        iDontHaveVaccinationCertificate: false,
        jawCertificateFile: null,
        vaccinationCertificateFile: null
    }

    const [certificatesObj, setCertificateObj] = useState(certInit)


    function cardClick() {
        if (showDetails?.isDailyShow) {
            if (!selectedDay?.value) {
                toast.error('web.showDayisRequired', 'Show Day is Required')
                return;
            } else {
                onClick(selectedDay?.value ?? '');
            }
        } else {
            onClick('');
        }
    }

    function dailyShowGoNext(toDoFunc) {
        if (showDetails?.isDailyShow && !!horse?.isQualified) {
            if (!selectedDay?.value) {
                toast.error('web.showDayisRequired', 'Show Day is Required')
                return;
            } else {
                setStep(-1);
                toDoFunc?.();
            }
        } else {
            setStep(-1);
            toDoFunc?.();
        }
    }

    const handleQualificationChange = (e) => {
        setQualificationObj({
            ...qualificationObj,
            [e.target.name]: e.target.value
        })
    };

    const qualObj = {
        CountryId: '',
        ShowName: '',
        Year: '',
        Class: '',
        Rank: ''
    }
    const [qualificationObj, setQualificationObj] = useState(qualObj)


    function submitQuilifications() {
        const theField = `${translate('web.theField', 'The Field')} `;
        const isrequired = ` ${translate('web.isRequired', 'Is Required')}`;
        if (isEmpty(qualificationObj.CountryId)) {
            toast.error(theField + translate('web.countryName', 'countryName') + isrequired);
            return false;
        }
        if (isEmpty(qualificationObj.ShowName)) {
            toast.error(theField + translate('web.showName', 'showName') + isrequired);
            return false;
        }
        if (isEmpty(qualificationObj.Year)) {
            toast.error(theField + translate('web.Year', 'Year') + isrequired);
            return false;
        }
        if (isEmpty(qualificationObj.Class)) {
            toast.error(theField + translate('web.className', 'className') + isrequired);
            return false;
        }
        if (isEmpty(qualificationObj.Rank)) {
            toast.error(theField + translate('web.Rank', 'Rank') + isrequired);
            return false;
        }
        if (!!qualificationObj?.websiteURL ?? false) {
            if (!isValidUrl(qualificationObj?.websiteURL)) {
                toast.error(theField + translate('web.urlNotValid', 'websiteURL'));
                return false;
            }
        }
        setIsSending(true);
        const obj = {
            id: horse?.id,
            countryId: qualificationObj.CountryId,
            showName: qualificationObj.ShowName,
            year: new Date(qualificationObj.Year),
            className: qualificationObj.Class,
            classRank: qualificationObj.Rank,
            website: qualificationObj?.websiteURL ?? '',
        }
        addedithorsequalification(obj).then((res) => {
            if (!!res) {
                setIsSending(false);
                {
                    toast.success(translate('web.qualificationsAddedSuccessfully', 'QualificationsAddedSuccessfully'))
                    setQualificationObj(qualObj)
                }
            } else {
                toast.error(translate('web.errorInAddingQualification', 'errorInAddingQualification'))
            }
        })
    }
    function submitCertificates() {
        const theField = `${translate('web.theField', 'The Field')} `;
        const isrequired = ` ${translate('web.isRequired', 'Is Required')}`;
        if (certificatesObj.iDontHaveJawCertificate == true && certificatesObj.iDontHaveVaccinationCertificate == true) {
            cardClick();
            closePopup();
            return;

        } else {
            if (certificatesObj.iDontHaveJawCertificate == false) {
                if (jawCertificate.length <= 0) {
                    toast.error(theField + `${translate('web.jawCertificate', 'jawCertificate')}` + isrequired);
                    throw new Error("Jaw Certificate is required");
                }
            }
            if (certificatesObj.iDontHaveVaccinationCertificate == false) {
                if (vaccinationCertificate.length <= 0) {
                    toast.error(theField + `${translate('web.vaccinationCertificate', 'vaccinationCertificate')}` + isrequired);
                    throw new Error("Vaccination Certificate is required");
                }
            }


            setIsSending(true);

            const formData = new FormData();
            formData.append('Id', horse?.id)
            if (jawCertificate.length > 0) {
                formData.append('JawCertificateFile', jawCertificate[0]?.file ?? null);
            }
            if (vaccinationCertificate.length > 0) {
                formData.append('VaccinationCertificateFile', vaccinationCertificate[0]?.file ?? null);
            }

            addHorseCertificates(formData).then((res) => {
                if (!!res) {
                    setIsSending(false);
                    {
                        toast.success(translate('web.certificatesAddedSuccessfully', 'Certificates Added Successfully'))
                        setJawCertificate([]);
                        setVaccinationCertificate([]);
                        setCertificateObj(certInit);
                        cardClick();
                        closePopup();
                    }
                } else {
                    setIsSending(false);
                    toast.error(translate('web.errorInAddingCertificates', 'error InAdding Certificates'))
                }
            })
        }
    }

    function deleteHorse() {
        if (horse?.showHorseId) {
            deleteShowEntry(horse?.showHorseId).then((res) => {
                if (res) {
                    toast.success(translate('web.horseDeletedSuccessfully', 'Horse Deleted Successfully'))
                    onClick();
                } else {
                    toast.error(translate('web.horseDeletedFaild', 'Horse Deleted Faild'))
                }
            })

        } else {
            onClick()
        }
    }

    function getHorseCert() {
        getHorseCertificates(horse?.id).then(res => {
            if (res?.jawCertificateFile != null) {
                setJawCertificate([{
                    documentUrl: res?.jawCertificateFile?.fileUrl,
                    file: res?.jawCertificateFile?.fileUrl,
                    name: res?.jawCertificateFile?.fileName,
                }])
            }
            if (res?.vaccinationCertificate != null) {
                setVaccinationCertificate([{
                    documentUrl: res?.vaccinationCertificate?.fileUrl,
                    file: res?.vaccinationCertificate?.fileUrl,
                    name: res?.vaccinationCertificate?.fileName,
                }])
            }
        })
    }


    function onOpenPopUp() {
        getHorseCert();
        getCountries().then((res) => {
            if (res.length <= 0) {
                toast.error(translate('web.erroringettingcountries', 'Error In getting Countries'))
                return;
            } else {
                setCountriesData(res);
            }
        });
        gethorsequalificationbyhorseid(horse?.id).then((res) => {
            const obg = {
                Class: res?.className,
                CountryId: res?.countryId,
                Rank: res?.classRank?.toString(),
                ShowName: res?.showName,
                Year: formatDate(res?.year, true, true)
            }
            setQualificationObj(obg);
        })
    }

    function reformatList(list) {
        const finalList = list.map((item) => ({
            text: item?.dayNameEn ?? '',
            value: item?.id ?? '',
            isDisabled: item?.avlPlaces <= 0 ? true : false,
            ...item
        }))
        return finalList;

    }


    const handleUpload = (e, setData) => {
        if (e.target.files && e.target.files.length > 0) {
            let checkFileSize = true;
            const fileListHook = [];

            for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
                if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
                    checkFileSize = false;
                    toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
                } else {
                    // Check allowed file types
                    const file = e.target.files[fileIndex];
                    const allowedMimeTypes = ['image/', 'application/pdf'];

                    if (!allowedMimeTypes.some(type => file.type.startsWith(type))) {
                        toast.error(translate("web.invalidFileType", "Only images and PDFs allowed."));
                        continue; // Skip to the next file if type is not allowed
                    }

                    fileListHook.push({
                        documentFile: URL.createObjectURL(e.target.files[fileIndex]),
                        name: e.target.files[fileIndex].name,
                        file: e.target.files[fileIndex],
                    });
                }
            }
            setData(fileListHook);
        }
    };

    function closePopup() {
        setStep(1);
        setJawCertificate([]);
        setVaccinationCertificate([]);
        setCertificateObj(certInit)
    }

    return (
        <div className={'hourseCardClass bg-white p-main border-15 p-3 mb-main'} style={{ minHeight: "unset" }}>
            <div className='w-100 fw-bold' >
                <i className=" fa-solid fa-chess-knight C89C66" />{horse?.regNr} - {horse?.name}
            </div>
            <div className='w-100' ><i className=" fa fa-calendar C89C66" />{formatDate(horse?.birthDate , false , false , true)}</div>
            {!!horse?.ownerName &&
                <div className='w-100' ><i className=" fa fa-user C89C66" />{horse?.ownerName}</div>
            }
            <div className='w-100' ><i className=" fa fa-globe-americas C89C66" />{horse?.origin}</div>
            {horse?.categoryName &&
                <div className='w-100' ><i className=" fa fa-tags C89C66" />{horse?.categoryName}</div>
            }
            {!horse?.isQualified &&
                <div className='w-100' ><i className=" fa fa-ban C89C66" />{!!horse?.notEligibleReason ? translate(`web.${convertToCamelCase(horse?.notEligibleReason)}`, horse?.notEligibleReason) : translate('web.notqualified', 'Not qualified')}</div>
            }
            {!showDetails?.isDailyShow && horse?.isSelected == false && (horse?.status == "" || horse?.status?.toLowerCase() == 'draft') && horse?.isQualified && !isInternationalHorse &&
                <CustomPopUp
                    onOpen={() => {
                        getHorseCert()
                    }}
                    onClose={() => closePopup()}
                    trigger={
                        <div className='position-absolute top-0 end-0 mt-3 me-3' title={translate('web.addHorse', 'Add')} style={{ cursor: 'pointer' }} ><i className=" fa C89C66 fa-plus"></i></div>
                    }
                    title={translate("web.reviewHorseCertificates", "Review Horse Certificates") + " " + `${horse?.regNr} - ${horse?.name}`}
                    content={
                        certificatesForm()
                    }
                    onClick={submitCertificates}
                />
            }
            {showDetails?.isDailyShow && horse?.isSelected == false && (horse?.status == "" || horse?.status?.toLowerCase() == 'draft') && horse?.isQualified && !isInternationalHorse &&
                <CustomPopUp
                    onOpen={() => {
                        getHorseCert()
                    }}
                    onClose={() => closePopup()}
                    trigger={
                        <div className='position-absolute top-0 end-0 mt-3 me-3' title={translate('web.addHorse', 'Add')} onClick={cardClick} style={{ cursor: 'pointer' }} ><i className=" fa C89C66 fa-plus"></i></div>
                    }
                    title={step > 0 ? translate("web.selectShowDay", "Select Show Day") + " " + `${horse?.regNr} - ${horse?.name}` : translate("web.reviewHorseCertificates", "Review Horse Certificates") + " " + `${horse?.regNr} - ${horse?.name}`}
                    content={
                        step > 0 ?
                            <EahsForm className='mb-main' >
                                <div className={eformInput} style={{ minHeight: 200 }}>
                                    <NetaqInput
                                        type='select'
                                        label={translate("web.selectDate", "Select Date")}
                                        required
                                        value={selectedDay}
                                        onChange={(selectedItem) => setSelectedDay(selectedItem)}
                                        placeholder={translate("web.selectDate", "Select Date")}
                                        name={"selectedDate"}
                                        listSelect={reformatList(showDetails?.showDaysList)}
                                        disabled={false}
                                    />
                                </div>
                            </EahsForm> :
                            certificatesForm()
                    }
                    goNext={step > 0}
                    btnText={step > 0 ? translate('web.next', 'next') : ""}
                    onNext={() => { dailyShowGoNext(); }}
                    onClick={cardClick}
                />
            }
            {isInternationalHorse &&
                <div className='position-absolute top-0 end-0 mt-3 me-3' title={translate('web.addHorse', 'Add')} onClick={() => navigate(`/addInternationalHorse?isEdit=true&horseId=${horse.id}&showId=${showId}&showNameAr=${showDetails?.showNameAr}&showNameEn=${showDetails?.showNameEn}`)} style={{ cursor: 'pointer' }} ><i className=" fa C89C66 fa-plus"></i></div>
            }
            {horse?.isSelected == false && (horse?.status == "" || horse?.status?.toLowerCase() == 'draft') && !horse?.isQualified && !horse.notEligibleReason && !isFoalHorse &&
                <CustomPopUp
                    onClose={() => closePopup()}
                    trigger={
                        <div className='position-absolute top-0 end-0 mt-3 me-3' title={translate('web.addQualifications', 'Add Qualifications')} style={{ cursor: 'pointer' }} ><i className=" fa C89C66 fa-plus"></i></div>
                    }
                    title={step > 0 ? (showDetails?.isDailyShow ? translate("web.selectShowDay", "Select Show Day") + " " + `${horse?.regNr} - ${horse?.name}` : translate("web.horsequalifications", "Horse Qualifications") + " " + `${horse?.regNr} - ${horse?.name}`) : translate("web.reviewHorseCertificates", "Review Horse Certificates") + " " + `${horse?.regNr} - ${horse?.name}`}
                    onOpen={() => {
                        onOpenPopUp()
                    }}
                    content={
                        step > 0 ?
                            <EahsForm className='mb-main' >
                                {showDetails?.isDailyShow &&
                                    <>
                                        <div className={'col-12 mb-4'} >
                                            <NetaqInput
                                                type='select'
                                                label={translate("web.selectDate", "Select Date")}
                                                required
                                                value={selectedDay}
                                                onChange={(selectedItem) => setSelectedDay(selectedItem)}
                                                placeholder={translate("web.selectDate", "Select Date")}
                                                name={"selectedDate"}
                                                listSelect={reformatList(showDetails?.showDaysList)}
                                                disabled={false}
                                            />
                                        </div>
                                        <h4 className='fw-bold'>
                                            {translate("web.horsequalifications", "Horse Qualifications")}
                                        </h4>
                                    </>}
                                <div className={eformInput}>
                                    <NetaqInput
                                        type='select'
                                        label={translate("web.countryName", "Country Name")}
                                        required
                                        value={countriesData.find((item) => item.value == qualificationObj?.CountryId)}
                                        onChange={(selectedItem) => setQualificationObj((prev) => ({ ...prev, CountryId: selectedItem?.value }))}
                                        placeholder={translate("web.countryName", "Country Name")}
                                        name={"countryQual"}
                                        listSelect={countriesData}
                                        disabled={qualificationObj?.noRequiredQualifications}

                                    />
                                </div>
                                <div className={eformInput}>
                                    <NetaqInput
                                        label={translate("web.showName", "Show Name")}
                                        name={"ShowName"}
                                        placeholder={translate("web.showName", "Show Name")}
                                        type={"text"}
                                        onChange={handleQualificationChange}
                                        value={qualificationObj?.ShowName}
                                        required={true}
                                        disabled={qualificationObj?.noRequiredQualifications}
                                    />
                                </div>
                                <div className={eformInput}>
                                    <NetaqInput
                                        name={"Year"}
                                        type={"normalDate"}
                                        label={translate("web.year", "Year")}
                                        onChange={handleQualificationChange}
                                        value={qualificationObj?.Year}
                                        required={true}
                                        disabled={qualificationObj?.noRequiredQualifications}
                                    />
                                </div>
                                <div className={eformInput}>
                                    <NetaqInput
                                        label={translate("web.className", "Class Name")}
                                        name={"Class"}
                                        placeholder={translate("web.className", "Class Name")}
                                        type={"text"}
                                        onChange={handleQualificationChange}
                                        value={qualificationObj?.Class}
                                        required={true}
                                        disabled={qualificationObj?.noRequiredQualifications}
                                    />
                                </div>
                                <div className={eformInput}>
                                    <NetaqInput
                                        type='number'
                                        name="Rank"
                                        label={translate("web.classRank", "Class Rank")}
                                        required
                                        min="1"
                                        step="1"
                                        onChange={handleQualificationChange}
                                        value={qualificationObj?.Rank}
                                        disabled={qualificationObj?.noRequiredQualifications}
                                    />
                                </div>
                                <div className={eformInput}>
                                    <NetaqInput
                                        label={translate(
                                            "web.referenceWebsiteURL",
                                            "Reference Website URL"
                                        )}
                                        name={"websiteURL"}
                                        placeholder={translate("web.websiteURL", "Website URL")}
                                        type={"text"}
                                        onChange={handleQualificationChange}
                                        value={qualificationObj?.websiteURL}
                                        disabled={qualificationObj?.noRequiredQualifications}
                                    />
                                    {qualificationObj?.websiteURL && (!isValidUrl(qualificationObj?.websiteURL)) &&
                                        <span className={`text-danger`}>
                                            {translate("web.urlNotValid", "URL not valid")}
                                        </span>
                                    }
                                </div>
                            </EahsForm>
                            :
                            certificatesForm()
                    }
                    goNext={step > 0}
                    btnText={step > 0 ? translate('web.next', 'next') : ""}
                    onNext={() => { dailyShowGoNext(submitQuilifications); }}
                    onClick={submitCertificates}
                />
            }
            {isSelectedTab && showDetails?.isInternationalShow && isInternationalHorse &&
                <div className='position-absolute bottom-0 end-0 mb-3 me-3' style={{ cursor: 'pointer' }} onClick={() => navigate(`/addInternationalHorse?isEdit=true&horseId=${horse.id}&showId=${showId}&showNameAr=${showDetails?.showNameAr}&showNameEn=${showDetails?.showNameEn}`)}>
                    <i className=" fa C89C66 fa-edit "></i>
                </div>
            }
            {showDetails?.isEarlyYearling && isFoalHorse &&
                <div className='position-absolute bottom-0 end-0 mb-3 me-3' style={{ cursor: 'pointer' }} onClick={() => navigate(`/addEarlyYearlingHorse?isEdit=true&horseId=${horse?.id}&showId=${showId}&${showDetails?.showNameAr}&showNameEn=${showDetails?.showNameEn}`)} >
                    <i className=" fa C89C66 fa-edit "></i>
                </div>
            }
            {isSelectedTab && (horse?.status == "" || horse?.status?.toLowerCase() == 'draft') &&
                <div className='position-absolute top-0 end-0 mt-3 me-3' style={{ cursor: 'pointer' }} onClick={() => { deleteHorse() }} >
                    <i className="fa C89C66 fa-trash"></i>
                </div>
            }
        </div>
    )

    function certificatesForm() {
        return <EahsForm className='mb-main'>
            <div className={eformInput} style={{ minHeight: 200 }}>
                <label class="capatalize_text">
                    {translate("web.vaccinationCertificate", "vaccinationCertificate")}
                </label>
                <UploadFile
                    text={"Upload"}
                    initialFiles={vaccinationCertificate}
                    isServer={vaccinationCertificate?.length > 0 &&
                        !!vaccinationCertificate[0]?.documentUrl}
                    onChange={(e) => handleUpload(e, setVaccinationCertificate)}
                    iconClassName={"fa-solid fa-upload fa-lg marginrightleft-5"}
                    accept="image/*,application/pdf"
                    isMulti={false}
                    disabled={!!certificatesObj?.iDontHaveVaccinationCertificate} />
                <NetaqInput
                    type='checkbox'
                    label={translate("web.uploadCertificateLater", "Select Date") + " (" + translate("web.vaccinationCertificate", "vaccinationCertificate") + ")"}
                    value={certificatesObj?.iDontHaveVaccinationCertificate}
                    checked={certificatesObj?.iDontHaveVaccinationCertificate}
                    onChange={(e) => setCertificateObj({
                        ...certificatesObj,
                        iDontHaveVaccinationCertificate: e.target.checked
                    })}
                    placeholder={translate("web.uploadCertificateLater", "Select Date")}
                    name={"vaccinationCertificate"}
                    disabled={!!vaccinationCertificate?.length > 0} />
            </div>
            <div className={eformInput} style={{ minHeight: 200 }}>
                <label class="capatalize_text">
                    {translate("web.jawCertificate", "vaccinationCertificate")}
                </label>
                <UploadFile
                    text={"Upload"}
                    initialFiles={jawCertificate}
                    isServer={jawCertificate?.length > 0 &&
                        !!jawCertificate[0]?.documentUrl}
                    onChange={(e) => handleUpload(e, setJawCertificate)}
                    iconClassName={"fa-solid fa-upload fa-lg marginrightleft-5"}
                    accept="image/*,application/pdf"
                    isMulti={false}
                    disabled={!!certificatesObj?.iDontHaveJawCertificate} />
                <NetaqInput
                    type='checkbox'
                    label={translate("web.uploadCertificateLater", "Select Date") + " (" + translate("web.jawCertificate", "vaccinationCertificate") + ")"}
                    value={certificatesObj?.iDontHaveJawCertificate}
                    checked={certificatesObj?.iDontHaveJawCertificate}
                    onChange={(e) => setCertificateObj({
                        ...certificatesObj,
                        iDontHaveJawCertificate: e.target.checked
                    })}
                    placeholder={translate("web.uploadCertificateLater", "Select Date")}
                    name={"jawCertificate"}
                    disabled={!!jawCertificate?.length > 0} />
            </div>
        </EahsForm>;
    }
}